"use client"
/* */
const emptyFunction = () => {
};
const callAndReact = (fn, options = {}) => {
  const {
    onSync = emptyFunction,
    onAsync = emptyFunction,
    then = emptyFunction,
    catch: $catch = emptyFunction,
    finally: $finally = emptyFunction
  } = options;
  try {
    const result = fn();
    if (result instanceof Promise) {
      onAsync();
      return result.then(then).catch($catch).finally($finally);
    } else {
      onSync();
      then(result);
      $finally();
      return result;
    }
  } catch (error) {
    onSync();
    $catch(error);
    $finally();
  }
};

export { callAndReact };
//# sourceMappingURL=callAndReact.mjs.map
